
function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global = globalThis;
    var parcelRequire = $parcel$global["parcelRequired477"];
var parcelRegister = parcelRequire.register;
parcelRegister("k3DAF", function(module, exports) {

$parcel$export(module.exports, "LivePagesFeedbackBanner", () => $54742b0dc618531d$export$ed78beec26fd1486);

var $gwFzn = parcelRequire("gwFzn");

var $2nPZH = parcelRequire("2nPZH");
var $4jR19 = parcelRequire("4jR19");
var $dBxQj = parcelRequire("dBxQj");

var $2Nwuj = parcelRequire("2Nwuj");

var $eEA8O = parcelRequire("eEA8O");

var $1qfLF = parcelRequire("1qfLF");

var $aUEBE = parcelRequire("aUEBE");

var $lnqHu = parcelRequire("lnqHu");

var $6f0Oj = parcelRequire("6f0Oj");
var $cwkWT = parcelRequire("cwkWT");
var $dcJ7R = parcelRequire("dcJ7R");
var $ecnYn = parcelRequire("ecnYn");

var $6ZZJK = parcelRequire("6ZZJK");

var $9wGTI = parcelRequire("9wGTI");

var $7aRa9 = parcelRequire("7aRa9");

var $5ijTm = parcelRequire("5ijTm");

var $g899D = parcelRequire("g899D");

var $luv00 = parcelRequire("luv00");

var $ep3mz = parcelRequire("ep3mz");

var $jhwJP = parcelRequire("jhwJP");

var $bttar = parcelRequire("bttar");
const $54742b0dc618531d$var$COMMUNITY_LINK_URL = 'https://community.atlassian.com/forums/Live-Docs-Beta/gh-p/Live-Pages-EAP';
const $54742b0dc618531d$var$FIND_OUT_MORE_LINK_URL = 'https://support.atlassian.com/confluence-cloud/docs/create-and-collaborate-in-real-time-with-live-docs/';
const $54742b0dc618531d$var$feedbackBannerStyles = (0, $ecnYn.xcss)({
    padding: 'space.050',
    borderBottom: `1px solid ${"var(--ds-border, #091E4224)"}`,
    backgroundColor: 'elevation.surface.sunken',
    color: 'color.text.subtle'
});
const $54742b0dc618531d$var$feedbackBannerLayerStyles = (0, $ecnYn.xcss)({
    zIndex: 'modal'
});
const $54742b0dc618531d$var$feedbackBannerMessageStyles = (0, $ecnYn.xcss)({
    gridArea: 'message'
});
const $54742b0dc618531d$var$closeButtonStyles = (0, $ecnYn.xcss)({
    display: 'flex',
    justifySelf: 'end',
    gridArea: 'close'
});
const $54742b0dc618531d$var$i18nBase = (0, $2nPZH.defineMessages)({
    bannerMessage: {
        id: "editor-action-bar.feedback-banner.message",
        defaultMessage: "This is a live page! Make edits instantly without having to publish. <link>Share feedback</link>"
    },
    bannerMessageViewOnly: {
        id: "editor-action-bar.feedback-banner.message-view-only",
        defaultMessage: "This is a live page! Anyone with edit access can make edits in real time without having to publish. <link>Share feedback</link>"
    },
    bannerClose: {
        id: "editor-action-bar.feedback-banner.close",
        defaultMessage: "Close"
    },
    collectorTitle: {
        id: "editor-action-bar.feedback-collector.title",
        defaultMessage: "Give feedback"
    },
    collectorTitleDetails: {
        id: "editor-action-bar.feedback-collector.title-details",
        defaultMessage: "Your thoughts are valuable and help us improve. {lineBreak}{lineBreak} If you\u2019d like to chat with us further and stay informed about this Early Access Program, join our {communityGroupLink}."
    },
    collectorCommunityGroup: {
        id: "editor-action-bar.feedback-collector.community-group",
        defaultMessage: "Community group"
    },
    flagTitle: {
        id: "editor-action-bar.feedback-flag.title",
        defaultMessage: "Thank you for your feedback"
    },
    flagDescription: {
        id: "editor-action-bar.feedback-flag.description",
        defaultMessage: "Stay in touch and stay informed about this Early Access Program."
    },
    flagCommunityGroup: {
        id: "editor-action-bar.feedback-flag.community-group",
        defaultMessage: "Join the Community group"
    },
    flagFindOutMore: {
        id: "editor-action-bar.feedback-flag.find-out-more",
        defaultMessage: "Find out more"
    }
});
const $54742b0dc618531d$var$i18nLiveDocs = (0, $2nPZH.defineMessages)({
    bannerMessage: {
        id: "editor-action-bar.feedback-banner.message.livedocs",
        defaultMessage: "This is a live doc! You can make updates instantly without having to publish. <link>Share feedback</link>"
    },
    bannerMessageViewOnly: {
        id: "editor-action-bar.feedback-banner.message-view-only.livedocs",
        defaultMessage: "This is a live doc! Anyone with edit access can make updates in real time without having to publish. <link>Share feedback</link>"
    }
});
const $54742b0dc618531d$var$i18n = (0, $jhwJP.mergeLiveDocI18n)($54742b0dc618531d$var$i18nBase, $54742b0dc618531d$var$i18nLiveDocs);
const $54742b0dc618531d$var$CommunityGroupLink = ()=>(0, $9wGTI.fg)('dst-a11y__replace-anchor-with-link__page-modes') ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $2Nwuj.default), {
        href: $54742b0dc618531d$var$COMMUNITY_LINK_URL,
        target: "_blank"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $4jR19.default), $54742b0dc618531d$var$i18n.collectorCommunityGroup)) : // eslint-disable-next-line @atlaskit/design-system/no-html-anchor
    /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement("a", {
        href: $54742b0dc618531d$var$COMMUNITY_LINK_URL,
        target: "_blank"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $4jR19.default), $54742b0dc618531d$var$i18n.collectorCommunityGroup));
const $54742b0dc618531d$var$LivePagesFeedbackBannerComponent = ({ isViewOnly: isViewOnly, flags: flags })=>{
    const { formatMessage: formatMessage } = (0, $dBxQj.default)();
    const [showBanner, setShowBanner] = (0, $gwFzn.useState)(!(0, $bttar.isBannerDismissed)());
    const [showFeedbackCollector, setShowFeedbackCollector] = (0, $gwFzn.useState)(false);
    const ssrPlaceholderIdProp = (0, $luv00.useSSRPlaceholderReplaceIdProp)();
    const [contentId] = (0, $ep3mz.usePageContentId)();
    const handleOnClickClose = ()=>{
        (0, $bttar.dismissBanner)();
        setShowBanner(false);
    };
    const handleOnClickFeedbackButton = ()=>{
        setShowFeedbackCollector(true);
    };
    const FeedbackCollectorOnSubmit = ()=>{
        (0, $bttar.permanentlyDismissBanner)();
        setShowFeedbackCollector(false);
    };
    const FeedbackCollectorOnSubmitWithFlag = ()=>{
        FeedbackCollectorOnSubmit();
        flags.showCustomFlag({
            title: formatMessage($54742b0dc618531d$var$i18n.flagTitle),
            description: formatMessage($54742b0dc618531d$var$i18n.flagDescription),
            customIcon: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($aUEBE))), {
                color: "var(--ds-icon-success, #22A06B)",
                label: ""
            }),
            actions: [
                {
                    content: formatMessage($54742b0dc618531d$var$i18n.flagCommunityGroup),
                    href: $54742b0dc618531d$var$COMMUNITY_LINK_URL,
                    target: '_blank'
                },
                {
                    content: formatMessage($54742b0dc618531d$var$i18n.flagFindOutMore),
                    href: $54742b0dc618531d$var$FIND_OUT_MORE_LINK_URL,
                    target: '_blank'
                }
            ]
        });
    };
    return showBanner ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement("div", {
        "data-vc": "live-pages-feedback-banner",
        ...ssrPlaceholderIdProp
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $cwkWT.default), {
        templateAreas: [
            'empty message close'
        ],
        templateColumns: "1fr auto 1fr",
        xcss: [
            $54742b0dc618531d$var$feedbackBannerStyles,
            $54742b0dc618531d$var$feedbackBannerLayerStyles
        ],
        testId: "live-pages-feedback-banner"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $dcJ7R.default), {
        space: "space.100",
        alignInline: "center",
        alignBlock: "center",
        xcss: $54742b0dc618531d$var$feedbackBannerMessageStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $5ijTm.LivePagesBetaLozenge), null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $4jR19.default), {
        ...isViewOnly ? $54742b0dc618531d$var$i18n.bannerMessageViewOnly : $54742b0dc618531d$var$i18n.bannerMessage,
        values: {
            link: (chunks)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $eEA8O.default), {
                    appearance: "link",
                    spacing: "none",
                    onClick: handleOnClickFeedbackButton
                }, chunks)
        }
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $6f0Oj.default), {
        xcss: $54742b0dc618531d$var$closeButtonStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $1qfLF.default), {
        appearance: "subtle",
        spacing: "compact",
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($lnqHu))),
        label: formatMessage($54742b0dc618531d$var$i18n.bannerClose),
        onClick: handleOnClickClose
    }))), showFeedbackCollector && ((0, $9wGTI.fg)('confluence_modernize_feedback_consolidation') ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $6ZZJK.GlobalFeedbackCollector), {
        onClose: ()=>setShowFeedbackCollector(false),
        onCloseComplete: ()=>{},
        onSubmit: FeedbackCollectorOnSubmit,
        feedbackSource: (0, $6ZZJK.FeedbackSource).LIVE_DOCS,
        additionalFields: {
            source: 'live-pages-feedback-banner'
        }
    }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $g899D.LiveEditFeedbackCollector), {
        feedbackTitle: formatMessage($54742b0dc618531d$var$i18n.collectorTitle),
        feedbackTitleDetails: formatMessage($54742b0dc618531d$var$i18n.collectorTitleDetails, {
            lineBreak: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement("br", null),
            communityGroupLink: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement($54742b0dc618531d$var$CommunityGroupLink, null)
        }),
        onClose: ()=>setShowFeedbackCollector(false),
        onSubmit: FeedbackCollectorOnSubmitWithFlag,
        source: "live-pages-feedback-banner",
        contentId: contentId
    }))) : null;
};
const $54742b0dc618531d$export$ed78beec26fd1486 = (0, $7aRa9.withFlags)($54742b0dc618531d$var$LivePagesFeedbackBannerComponent);

});
parcelRegister("5ijTm", function(module, exports) {

$parcel$export(module.exports, "LivePagesBetaLozenge", () => $f0e665314235adeb$export$a5918700383e7a93);

var $gwFzn = parcelRequire("gwFzn");

var $2nPZH = parcelRequire("2nPZH");
var $4jR19 = parcelRequire("4jR19");

var $5nBzc = parcelRequire("5nBzc");

var $9wGTI = parcelRequire("9wGTI");
const $f0e665314235adeb$var$i18n = (0, $2nPZH.defineMessages)({
    beta: {
        id: "live-pages-features.beta.lozenge",
        defaultMessage: "Beta"
    },
    new: {
        id: "live-pages-features.new.lozenge",
        defaultMessage: "New"
    }
});
const $f0e665314235adeb$export$a5918700383e7a93 = ({ bold: bold = false })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $5nBzc.default), {
        appearance: "new",
        isBold: bold
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $4jR19.default), (0, $9wGTI.fg)('live_pages_ga_ui') ? $f0e665314235adeb$var$i18n.new : $f0e665314235adeb$var$i18n.beta));

});

parcelRegister("g899D", function(module, exports) {

$parcel$export(module.exports, "LiveEditFeedbackCollector", () => $31b5be37a70e0426$export$d3248584df53927e);

var $gwFzn = parcelRequire("gwFzn");

var $biiXa = parcelRequire("biiXa");

var $bQm3c = parcelRequire("bQm3c");

var $gTyTP = parcelRequire("gTyTP");
const $31b5be37a70e0426$var$ENTRYPOINT_ID = 'bf16aa36-e955-4ced-b505-fdbf402ac7c0';
const $31b5be37a70e0426$var$FEEDBACK_CONTEXT_ID = 'customfield_10047';
const $31b5be37a70e0426$export$d3248584df53927e = ({ feedbackTitle: feedbackTitle, feedbackTitleDetails: feedbackTitleDetails, customTextAreaLabel: customTextAreaLabel, summaryPlaceholder: summaryPlaceholder, onClose: onClose, onSubmit: onSubmit, cancelButtonLabel: cancelButtonLabel, submitButtonLabel: submitButtonLabel, source: source, contentId: contentId })=>{
    const { livePageReleasePhase: livePageReleasePhase } = (0, $gTyTP.useIsLivePagesFeatureEnabled)();
    const { displayName: displayName, userId: userId, cloudId: cloudId, edition: edition, environment: environment } = (0, $bQm3c.useSessionData)();
    const getFeedbackMetadata = ()=>{
        const feedbackMetadata = {
            location: window.location.hostname,
            userId: userId ?? '',
            cloudId: cloudId ?? '',
            contentId: contentId,
            edition: edition ?? '',
            source: source,
            environment: environment ?? '',
            'Live Pages Release Phase': livePageReleasePhase
        };
        // format the metadata for better readability in the feedback collector
        return JSON.stringify(feedbackMetadata, null, 2);
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $biiXa.default), {
        entrypointId: $31b5be37a70e0426$var$ENTRYPOINT_ID,
        name: displayName ?? undefined,
        atlassianAccountId: userId ?? undefined,
        showTypeField: false,
        feedbackTitle: feedbackTitle,
        feedbackTitleDetails: feedbackTitleDetails,
        additionalFields: [
            {
                id: $31b5be37a70e0426$var$FEEDBACK_CONTEXT_ID,
                value: getFeedbackMetadata()
            }
        ],
        customTextAreaLabel: customTextAreaLabel,
        summaryPlaceholder: summaryPlaceholder,
        onClose: onClose,
        onSubmit: onSubmit,
        cancelButtonLabel: cancelButtonLabel,
        submitButtonLabel: submitButtonLabel
    });
};

});

parcelRegister("bttar", function(module, exports) {

$parcel$export(module.exports, "isBannerDismissed", () => $6f21afd3b78c5fe9$export$d9853b07d3a8476b);
$parcel$export(module.exports, "dismissBanner", () => $6f21afd3b78c5fe9$export$775e775a1048dbdb);
$parcel$export(module.exports, "permanentlyDismissBanner", () => $6f21afd3b78c5fe9$export$f6b01b0b3935b76b);

var $e9zUf = parcelRequire("e9zUf");
var $1UApO = parcelRequire("1UApO");

var $7W8i8 = parcelRequire("7W8i8");
const $6f21afd3b78c5fe9$var$logger = (0, $7W8i8.getLogger)('LivePagesFeedbackBanner');
const $6f21afd3b78c5fe9$var$MAX_DISMISS_COUNT = 3;
const $6f21afd3b78c5fe9$var$ONE_DAY_IN_MS = 86400000; // 24 hours in milliseconds
const $6f21afd3b78c5fe9$var$TWO_WEEKS_IN_MS = 14 * $6f21afd3b78c5fe9$var$ONE_DAY_IN_MS; // 2 weeks in milliseconds
const $6f21afd3b78c5fe9$var$STORAGE_KEY = (0, $1UApO.PERSISTED_KEYS_ON_SERVER).PERSISTED_LIVE_PAGES_FEEDBACK_BANNER_LAST_DISMISSED;
const $6f21afd3b78c5fe9$var$DISMISSAL_PERIODS = [
    0,
    $6f21afd3b78c5fe9$var$ONE_DAY_IN_MS,
    $6f21afd3b78c5fe9$var$TWO_WEEKS_IN_MS
];
const $6f21afd3b78c5fe9$var$getLocalStorageItem = ()=>{
    try {
        const itemString = (0, $e9zUf.confluenceLocalStorageInstance).getItem($6f21afd3b78c5fe9$var$STORAGE_KEY);
        if (!itemString) return {};
        const item = JSON.parse(itemString);
        if (typeof item === 'object' && item !== null && !Array.isArray(item) && (typeof item.time === 'number' || item.time === undefined) && (typeof item.count === 'number' || item.count === undefined)) return item;
    } catch (error) {
        $6f21afd3b78c5fe9$var$logger.error`Error parsing local storage key(${$6f21afd3b78c5fe9$var$STORAGE_KEY}): ${error}`;
    }
    (0, $e9zUf.confluenceLocalStorageInstance).setItem($6f21afd3b78c5fe9$var$STORAGE_KEY, JSON.stringify({}));
    return {};
};
const $6f21afd3b78c5fe9$var$updateLocalStorageItem = (item)=>{
    try {
        (0, $e9zUf.confluenceLocalStorageInstance).setItem($6f21afd3b78c5fe9$var$STORAGE_KEY, JSON.stringify(item));
    } catch (error) {
        $6f21afd3b78c5fe9$var$logger.error`Error setting local storage key(${$6f21afd3b78c5fe9$var$STORAGE_KEY}): ${error}`;
    }
};
const $6f21afd3b78c5fe9$export$d9853b07d3a8476b = ()=>{
    const { time: time = 0, count: count = 0 } = $6f21afd3b78c5fe9$var$getLocalStorageItem();
    const currentTime = Date.now();
    if (count >= $6f21afd3b78c5fe9$var$MAX_DISMISS_COUNT) return true; // Permanently dismissed
    const requiredDuration = $6f21afd3b78c5fe9$var$DISMISSAL_PERIODS[count] ?? 0;
    return currentTime - time < requiredDuration;
};
const $6f21afd3b78c5fe9$var$updateBannerDismissal = (count)=>{
    const item = $6f21afd3b78c5fe9$var$getLocalStorageItem();
    const currentTime = Date.now();
    item.time = currentTime;
    item.count = count;
    $6f21afd3b78c5fe9$var$updateLocalStorageItem(item);
};
const $6f21afd3b78c5fe9$export$775e775a1048dbdb = ()=>{
    const item = $6f21afd3b78c5fe9$var$getLocalStorageItem();
    const newCount = (item.count ?? 0) + 1;
    if (newCount >= $6f21afd3b78c5fe9$var$MAX_DISMISS_COUNT) $6f21afd3b78c5fe9$export$f6b01b0b3935b76b();
    else $6f21afd3b78c5fe9$var$updateBannerDismissal(newCount);
};
const $6f21afd3b78c5fe9$export$f6b01b0b3935b76b = ()=>{
    $6f21afd3b78c5fe9$var$updateBannerDismissal($6f21afd3b78c5fe9$var$MAX_DISMISS_COUNT);
};

});



//# sourceMappingURL=LivePagesFeedbackBanner.f53e5e0c.js.map
